import { createIcon } from '../createIcon';

export const ScrollIconConfig = {
  name: 'ScrollIcon',
  height: 512,
  width: 640,
  svgPath: 'M48 0C21.53 0 0 21.53 0 48v64c0 8.84 7.16 16 16 16h80V48C96 21.53 74.47 0 48 0zm208 412.57V352h288V96c0-52.94-43.06-96-96-96H111.59C121.74 13.41 128 29.92 128 48v368c0 38.87 34.65 69.65 74.75 63.12C234.22 474 256 444.46 256 412.57zM288 384v32c0 52.93-43.06 96-96 96h336c61.86 0 112-50.14 112-112 0-8.84-7.16-16-16-16H288z',
  yOffset: 0,
  xOffset: 0,
};

export const ScrollIcon = createIcon(ScrollIconConfig);

export default ScrollIcon;